"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageFeatures = void 0;
var rectangle_1 = require("../../../geometry/rectangle");
var color_1 = require("./color");
var explicit_content_1 = require("./explicit-content");
var label_1 = require("./label");
var ImageFeatures = /** @class */ (function () {
    function ImageFeatures(data) {
        this.colors = [];
        this.explicitContent = [];
        this.faces = [];
        this.labels = [];
        this.colors = data.colors.map(function (color) {
            return new color_1.Color(color);
        });
        this.explicitContent = data.explicitContent.map(function (explicitContent) {
            return new explicit_content_1.ExplicitContent(explicitContent);
        });
        this.faces = data.faces.map(function (face) {
            return new rectangle_1.Rectangle(face.width, face.height, face.x, face.y);
        });
        this.labels = data.labels.map(function (label) {
            return new label_1.Label(label);
        });
    }
    return ImageFeatures;
}());
exports.ImageFeatures = ImageFeatures;
//# sourceMappingURL=image-features.js.map